(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-preview"] && !Shopify.designMode) return;
  try {
    const initProductDescriptionPreviews = (root) => {
    const previews = root.querySelectorAll('[data-product-description-preview]:not([data-product-description-preview-initialized])');

    previews.forEach((preview) => {
      const content = preview.querySelector('[data-product-description-preview-content]');
      const toggle = preview.querySelector('[data-product-description-preview-toggle]');

      preview.setAttribute('data-product-description-preview-initialized', 'true');

      if (!content || !toggle) return;

      const children = Array.from(content.children).filter((child) => child.textContent.trim().length > 0);

      if (!children.length) return;

      const visibleElements = [];
      const firstHeadingIndex = children.findIndex((child) => /^H[1-6]$/.test(child.tagName));

      if (firstHeadingIndex >= 0) {
        visibleElements.push(children[firstHeadingIndex]);
        const firstParagraphAfterHeading = children.slice(firstHeadingIndex + 1).find((child) => child.tagName === 'P');
        if (firstParagraphAfterHeading) visibleElements.push(firstParagraphAfterHeading);
      } else {
        visibleElements.push(children[0]);
        const firstParagraphAfterFirstElement = children.slice(1).find((child) => child.tagName === 'P');
        if (firstParagraphAfterFirstElement) visibleElements.push(firstParagraphAfterFirstElement);
      }

      visibleElements.forEach((element) => element.classList.add('product-description-preview__visible'));

      if (visibleElements.length < children.length) {
        const lastVisibleElement = visibleElements[visibleElements.length - 1];

        if (lastVisibleElement) {
          lastVisibleElement.append(' ');
          lastVisibleElement.appendChild(toggle);
        }

        toggle.hidden = false;
      }

      toggle.addEventListener('click', () => {
        preview.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.hidden = true;
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initProductDescriptionPreviews(document));
  document.addEventListener('shopify:section:load', (event) => initProductDescriptionPreviews(event.target));
  } catch(e) { console.error(e); }
})();

})();
